import React from "react";

import { IBaseField } from "../models/formFields.interfaces";
import { AbstractFormField, IFormFieldState } from "./AbstractFormField";

export abstract class AbstractInput<
    FieldName extends string,
    IProps extends IBaseField<HTMLInputElement, FieldName>,
    IState extends IFormFieldState,
> extends AbstractFormField<FieldName, HTMLInputElement, IProps, IState> {
    protected updateValueAttribute(
        event: React.FormEvent<HTMLInputElement>,
    ): void {
        this.value = event.currentTarget.value;
    }
}
